import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import ViewHeader from '../components/ViewHeader';
import KpiCard from '../components/KpiCard';

const kpis = [
    { title: 'Total active Vets', value: '3' },
    { title: 'Total surgeries', value: '4' },
    { title: 'Consultations', value: '6' },
];

const workloadData = [
    { time: '10:00 AM', 'dr ali': 0, 'dr ahmad': 1, 'dr haya': 1 },
    { time: '11:00 AM', 'dr ali': 1, 'dr ahmad': 0, 'dr haya': 2 },
    { time: '12:00 PM', 'dr ali': 2, 'dr ahmad': 3, 'dr haya': 4 },
    { time: '1:00 PM', 'dr ali': 3, 'dr ahmad': 1, 'dr haya': 1 },
    { time: '2:00 PM', 'dr ali': 2, 'dr ahmad': 3, 'dr haya': 3 },
    { time: '3:00 PM', 'dr ali': 1, 'dr ahmad': 3, 'dr haya': 1 },
    { time: '4:00 PM', 'dr ali': 0, 'dr ahmad': 0, 'dr haya': 0 },
    { time: '5:00 PM', 'dr ali': 2, 'dr ahmad': 3, 'dr haya': 1 },
    { time: '6:00 PM', 'dr ali': 3, 'dr ahmad': 4, 'dr haya': 0 },
];

const vetTable = [
    { vet: 'Ali', total: 4, consulting: 2, inpatient: 3, procedure: 2, status: 'Medium' },
    { vet: 'Ahmad', total: 3, consulting: 1, inpatient: 4, procedure: 2, status: 'Medium' },
    { vet: 'haya', total: 5, consulting: 1, inpatient: 4, procedure: 4, status: 'high' },
];

const upcomingSurgeries = [
    { pet: 'Ginger', procedure: 'spay', date: 'May 5' },
    { pet: 'Bella', procedure: 'ear hematoma', date: 'May 6' },
    { pet: 'Max', procedure: 'castration', date: 'May 6' },
];

const VET_COLORS = ['#0f4c5c', '#f97316', '#10b981'];

const VeterinarianWorkload = ({ onBack }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', flex: 1, minHeight: 0 }}>
            <ViewHeader title="Veterinarian Workload" subtitle="Today" onBack={onBack} />

            {/* Top row */}
            <div style={{ display: 'flex', gap: '16px' }}>
                {/* Key metrics */}
                <div className="clinic-dashboard-section-card" style={{ flex: 1, animationDelay: '0ms' }}>
                    <div className="clinic-dashboard-section-title">Key metrics</div>
                    <div className="clinic-dashboard-kpi-row">
                        {kpis.map((kpi, i) => <KpiCard key={i} {...kpi} />)}
                    </div>
                </div>

                {/* Workload over time */}
                <div className="clinic-dashboard-section-card" style={{ flex: 1, display: 'flex', flexDirection: 'column', animationDelay: '80ms' }}>
                    <div className="clinic-dashboard-section-title">Workload over time (today)</div>
                    <div className="clinic-dashboard-chart-wrap" style={{ minHeight: '200px' }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart data={workloadData} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                                <XAxis
                                    dataKey="time"
                                    axisLine={false}
                                    tickLine={false}
                                    tick={{ fill: '#9ca3af', fontSize: 10 }}
                                />
                                <YAxis
                                    axisLine={false}
                                    tickLine={false}
                                    tick={{ fill: '#9ca3af', fontSize: 12 }}
                                />
                                <Tooltip
                                    contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                                />
                                <Line animationBegin={600} type="monotone" dataKey="dr ali" stroke={VET_COLORS[0]} strokeWidth={2} dot={{ r: 3 }} />
                                <Line animationBegin={600} type="monotone" dataKey="dr ahmad" stroke={VET_COLORS[1]} strokeWidth={2} dot={{ r: 3 }} />
                                <Line animationBegin={600} type="monotone" dataKey="dr haya" stroke={VET_COLORS[2]} strokeWidth={2} dot={{ r: 3 }} />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            </div>

            {/* Bottom row */}
            <div style={{ display: 'flex', gap: '16px', flex: 1, minHeight: 0 }}>
                {/* Vet workload table */}
                <div className="clinic-dashboard-section-card" style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', animationDelay: '160ms' }}>
                    <div className="clinic-dashboard-section-title">Vet Workload</div>
                    <div style={{ overflow: 'auto', flex: 1 }}>
                        <table className="clinic-dashboard-table">
                            <thead>
                                <tr>
                                    <th>vet</th>
                                    <th>Total Apt</th>
                                    <th>consulting</th>
                                    <th>inpatient</th>
                                    <th>Presedure</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {vetTable.map((row, i) => (
                                    <tr key={i}>
                                        <td>{row.vet}</td>
                                        <td>{row.total}</td>
                                        <td>{row.consulting}</td>
                                        <td>{row.inpatient}</td>
                                        <td>{row.procedure}</td>
                                        <td>
                                            <span className={`clinic-dashboard-status-badge ${row.status.toLowerCase()}`}>
                                                {row.status}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Upcoming surgeries */}
                <div className="clinic-dashboard-section-card" style={{ flex: 0.7, display: 'flex', flexDirection: 'column', animationDelay: '240ms' }}>
                    <div className="clinic-dashboard-section-title">Upcoming surgeries</div>
                    <div className="clinic-dashboard-surgery-list" style={{ flex: 1, justifyContent: 'center' }}>
                        {upcomingSurgeries.map((surgery, i) => (
                            <div key={i} className="clinic-dashboard-surgery-item">
                                <div className="clinic-dashboard-surgery-info">
                                    <span className="clinic-dashboard-surgery-pet">{surgery.pet}</span>
                                    <span className="clinic-dashboard-surgery-procedure">{surgery.procedure}</span>
                                </div>
                                <span className="clinic-dashboard-surgery-date">{surgery.date}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VeterinarianWorkload;
